import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FdsDirectivesModule } from '@fmr-ap153177/fdskit-angular-directives';
import {
  FdsLink,
  FdsLabel,
  FdsTab,
  FdsTabGroup,
  FdsTabPanel,
  FdsFootnoteAnnotation,
  FdsFootnotes,
  FdsFootnote,
  FdsSegmentedControl,
  FdsSegment,
  FdsButton,
  FdsRadioGroup,
  FdsRadio,
  FdsIcon,
  FdsSelect,
  injectCustomSpriteSheet,
  FdsCheckbox,
  FdsCheckboxGroup,
  FdsTitle,
  FdsTooltip,
  FdsModal,
  FdsNumberStepper,
  FdsMessage,
  FdsForm,
  FdsMicrocopy,
  FdsInput,
  FdsNumericInput,
  FdsLoadingIndicator,
  FdsInlineMessage,
  FdsContentBlock,
  FdsProgressStatus,

  // Icons
  ICON_DOWNLOAD,
  ICON_PERFORMANCE_LOSS,
  ICON_PERFORMANCE_GAIN,
  ICON_PREVIOUS,
  ICON_NEXT,
  ICON_SORTED_DESCENDING,
  ICON_SORTABLE,
  ICON_CLOSE,
  ICON_CANCEL,
  ICON_HELP,
  ICON_REFRESH,
  ICON_WARNING,
  ICON_SELECTED,
  ICON_OPEN_LINK,
} from '@fmr-ap153177/fdskit';

injectCustomSpriteSheet([
  ICON_PERFORMANCE_LOSS,
  ICON_PERFORMANCE_GAIN,
  ICON_PREVIOUS,
  ICON_NEXT,
  ICON_REFRESH,
  ICON_HELP,
  ICON_CLOSE,
  ICON_CANCEL,
  ICON_DOWNLOAD,
  ICON_SORTED_DESCENDING,
  ICON_SORTABLE,
  ICON_WARNING,
  ICON_SELECTED,
  ICON_OPEN_LINK,
]);
FdsLink.defineCustomElement();
FdsLabel.defineCustomElement();
FdsTab.defineCustomElement();
FdsTabGroup.defineCustomElement();
FdsTabPanel.defineCustomElement();
FdsFootnoteAnnotation.defineCustomElement();
FdsFootnotes.defineCustomElement();
FdsFootnote.defineCustomElement();
FdsSegmentedControl.defineCustomElement();
FdsSegment.defineCustomElement();
FdsButton.defineCustomElement();
FdsRadioGroup.defineCustomElement();
FdsRadio.defineCustomElement();
FdsIcon.defineCustomElement();
FdsSelect.defineCustomElement();
FdsCheckbox.defineCustomElement();
FdsCheckboxGroup.defineCustomElement();
FdsTitle.defineCustomElement();
FdsTooltip.defineCustomElement();
FdsModal.defineCustomElement();
FdsProgressStatus.defineCustomElement();
FdsNumberStepper.defineCustomElement();
FdsMessage.defineCustomElement();
FdsForm.defineCustomElement();
FdsMicrocopy.defineCustomElement();
FdsInput.defineCustomElement();
FdsInlineMessage.defineCustomElement();
FdsLoadingIndicator.defineCustomElement();
FdsContentBlock.defineCustomElement();
FdsNumericInput.defineCustomElement();

@NgModule({
  declarations: [],
  imports: [CommonModule, FdsDirectivesModule],
})
export class FdsModule {}
